/* @flow */
import * as React from 'react';
import RequireUser from 'lib/RequireUser';
import RequireDesktop from 'lib/RequireDesktop';
import { Route, IndexRoute } from 'react-router';
import chainOnEnter from 'components/lib/chainOnEnter';
import OauthConfigPage from './components/OauthConfigPage';
import IntegrationPageIndex from './components/IntegrationPageIndex';
import IntegrationSettingsPage from './components/IntegrationSettingsPage';
import IntegrationSettingsIndex from './components/IntegrationSettingsIndex';
import ContentSourceProviderPage from './components/ContentSourceProviderPage';
import IntegrationSettingsNotFound from './components/IntegrationSettingsNotFound';
import OrganizationDeveloperConsoleAuthorizer from './components/OrganizationDeveloperConsoleAuthorizer';

const onEnter = chainOnEnter([RequireDesktop, RequireUser]);

function IntegrationPage(props) {
  return (
    <OrganizationDeveloperConsoleAuthorizer uuid={props.params.uuid}>
      {({ authorized }) => {
        if (!authorized) {
          return <IntegrationSettingsNotFound />;
        }

        return (
          <IntegrationSettingsPage uuid={props.params.uuid}>
            {props.children}
          </IntegrationSettingsPage>
        );
      }}
    </OrganizationDeveloperConsoleAuthorizer>
  );
}

export default (
  <Route path="/integrations(/)" onEnter={onEnter}>
    <IndexRoute component={IntegrationSettingsIndex} />
    <Route path=":uuid" component={IntegrationPage}>
      <IndexRoute component={IntegrationPageIndex} />
      <Route path="oauth" component={OauthConfigPage} />
      <Route path="content" component={ContentSourceProviderPage} />
    </Route>
  </Route>
);
